module.exports = __webpack_public_path__ + "img/house_02.fbfa4098.jpg";